import * as LL from './graph';
import * as HL from './hl';

let globalId = 0;

export interface NormGraph {
  ops: Map<HL.EditingOp, number>;
  voidNodes: Map<LL.VoidNode, number>;
  constNodes: Map<LL.ConstNode, number>;
  varNodes: Map<LL.VarNode, number>;
  outputNodes: Map<HL.EditingOutputNode, number>;
}

function visitOp(ng: NormGraph, op: HL.EditingOp): number {
  const opId = ng.ops.get(op);
  if (opId != null) {
    return opId;
  }
  const id = globalId++;
  ng.ops.set(op, id);
  for (const argNode of Object.values(op.inputs)) {
    visitNode(ng, argNode);
  }
  return id;
}

function visitNode(ng: NormGraph, node: HL.EditingNode): number {
  if (node.nodeType === 'const') {
    const nodeId = ng.constNodes.get(node);
    if (nodeId != null) {
      return nodeId;
    }
    const id = globalId++;
    ng.constNodes.set(node, id);
    return id;
  } else if (node.nodeType === 'var') {
    const nodeId = ng.varNodes.get(node);
    if (nodeId != null) {
      return nodeId;
    }
    const id = globalId++;
    ng.varNodes.set(node, id);
    return id;
  } else if (node.nodeType === 'output') {
    const nodeId = ng.outputNodes.get(node);
    if (nodeId != null) {
      return nodeId;
    }
    const id = globalId++;
    ng.outputNodes.set(node, id);
    visitOp(ng, node.fromOp);
    return id;
  } else if (node.nodeType === 'void') {
    const nodeId = ng.voidNodes.get(node);
    if (nodeId != null) {
      return nodeId;
    }
    const id = globalId++;
    ng.voidNodes.set(node, id);
    return id;
  }
  throw new Error('invalid');
}

export function graphNorm(node: HL.EditingNode) {
  // TODO: do we need to use WeakMap to avoid leaks?
  const ng: NormGraph = {
    ops: new Map(),
    constNodes: new Map(),
    varNodes: new Map(),
    outputNodes: new Map(),
    voidNodes: new Map(),
  };
  visitNode(ng, node);
  return ng;
}
